import ButtonsContainer from '../../Component/Buttons/Buttons'

const Buttons = () => {
  return (
    <div className='page-body'>
      <ButtonsContainer />
    </div>
  )
}

export default Buttons